import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import AdminLayout from '../components/layout/AdminLayout';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import TenantList from '../pages/Tenants/TenantList';
import TenantDetail from '../pages/Tenants/TenantDetail';
import DealerList from '../pages/Dealers/DealerList';
import DealerDetail from '../pages/Dealers/DealerDetail';
import PendingVerification from '../pages/Verification/PendingVerification';

import NotFound from '../pages/NotFound';

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="pending-verification" element={<PendingVerification />} />
        <Route path="tenants" element={<TenantList />} />
        <Route path="tenants/:id" element={<TenantDetail />} />
        <Route path="dealers" element={<DealerList />} />
        <Route path="dealers/:id" element={<DealerDetail />} />

      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
